import ssapi from 'lib/api/secondstepApi'
import { addNotification } from '../notifications'
import * as types from '../actionTypes'

const intitialState = {
  isLoading: false,
  currentUser: null,
  currentUserFetchedAt: null,
}

export const fetchingCurrentUser = () => ({
  type: types.FETCHING_CURRENT_USER,
})

export const setCurrentUserError = error => {
  return {
    type: types.SET_CURRENT_USER_ERROR,
    error: error || 'Error fetching current user',
  }
}

export const setCurrentUserSuccess = data => {
  return {
    type: types.SET_CURRENT_USER_SUCCESS,
    currentUser: data,
  }
}

export const fetchCurrentUserAndHandler = () => {
  return async function (dispatch) {
    dispatch(fetchingCurrentUser())

    try {
      const response = await ssapi.getUserProfile()
      if (response.data.groupMembership) {
        response.data.isCssAdmin =
          response.data.groupMembership.includes('CSS Admins')
        response.data.isTechnologyAdmin =
          response.data.groupMembership.includes('Technology Admins')
        response.data.isOperationsAdmin =
          response.data.groupMembership.includes('Operations Admins')
      } else {
        response.data.isCssAdmin = false
        response.data.isTechnologyAdmin = false
        response.data.isOperationsAdmin = false
      }

      response.data.isAdmin =
        response.data.isCssAdmin ||
        response.data.isTechnologyAdmin ||
        response.data.isOperationsAdmin

      if (response.data.netSuiteCustomerId === 0) {
        response.data.organizationName = response.data.siteName
      }
      response.data.companyName = response.data.siteName
      response.data.netsuiteCustomerId = response.data.netSuiteCustomerId

      dispatch(setCurrentUserSuccess(response.data))

      if (response.data.notifications.length) {
        response.data.notifications.map(note => {
          dispatch(addNotification({ color: note.color, text: note.text }))
          return null
        })
      }

      return response.data
    } catch (error) {
      dispatch(setCurrentUserError(error))
      return false
    }
  }
}

export default (state = intitialState, action) => {
  switch (action.type) {
    case types.FETCHING_CURRENT_USER:
      return {
        ...state,
        isLoading: true,
      }
    case types.SET_CURRENT_USER_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      }
    case types.SET_CURRENT_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        currentUser: action.currentUser,
        currentUserFetchedAt: new Date(),
      }
    default:
      return state
  }
}
